import Modal from "/WebInterface/new-ui/modules/modal.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import Loader from "/WebInterface/new-ui/modules/loader/loader.js";
import TagInput from "/WebInterface/new-ui/modules/tag-input/tag-input.js";
import MultiSelect from "/WebInterface/new-ui/modules/multi-select/multi-select.js";
import { growl } from "/WebInterface/new-ui/modules/toast.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import { apiCall } from "/WebInterface/new-ui/assets/js/utils/api/apis.js";
import {
  resultTemplate,
  customShareTemplate,
  errorResponseTemplate,
} from "./template.js";
import { ajax } from "/WebInterface/new-ui/assets/js/utils/ajax.js";
import store from "/WebInterface/new-ui/store/index.js";
import { convertClassesToInlineStyles } from "/WebInterface/new-ui/assets/js/utils/sceditor-email-converter.js";

let currentShareBodyEditor;
let customShareShareType;
let tagInput;
let multiSelect;

const addDays = (days) => {
  const date = new Date();
  date.setDate(date.getDate() + Number(days));

  return date;
};

const getEditorValue = () => {
  if (!currentShareBodyEditor)
    return "A user would like to share a file with you.  This link will expire on {date} at {time}\r\n\r\n{web_link}\r\n\r\n\r\n";
  const editor = sceditor.instance(currentShareBodyEditor);
  let html = "";
  if (editor) {
    html = editor.val();
  } else {
    html = _$(currentShareBodyEditor).val();
  }
  
  // Convert CSP-compliant classes to inline styles for email compatibility
  // Email clients don't support external CSS, so inline styles are required
  if (html) {
    return convertClassesToInlineStyles(html);
  }
  
  return html;
};

const getShareFormData = (dialog) => {
  let formData = utils.serializeInputs(dialog.root, false, false);

  const hasShareTagInput =
    _$("#shareUsernames").el() && !_$("#shareUsernames").hasClass("is-hidden");

  const hasShareMultiSelect =
    _$("#shareUsernames-multiselect").el() &&
    !_$("#shareUsernames-multiselect").hasClass("is-hidden");

  if (hasShareTagInput) {
    const { shareUsernames } = utils.serializeInputs(
      _$("#shareUsernames").parent().el(),
      false,
      false
    );

    formData = { ...formData, shareUsernames };
  }

  if (hasShareMultiSelect) {
    const { shareUsernames_multiselect } = utils.serializeInputs(
      _$("#shareUsernames-multiselect").el(),
      false,
      false
    );

    formData = { ...formData, shareUsernames: shareUsernames_multiselect };
  }

  let emailText = getEditorValue();
  let shareBody = emailText
    .replace(
      '<span id="sceditor-end-marker" class="sceditor-selection sceditor-ignore lh-0 d-n"> </span><span id="sceditor-start-marker" class="sceditor-selection sceditor-ignore lh-0 d-n"> </span>',
      ""
    )
    .replace(
      '<span id="sceditor-start-marker" class="sceditor-selection sceditor-ignore lh-0 d-n"> </span><span id="sceditor-end-marker" class="sceditor-selection sceditor-ignore lh-0 d-n"> </span>',
      ""
    );

  return { ...formData, shareBody };
};

const submitSharingForm = (
  dialog,
  data,
  paths,
  files,
  defaultCustomShareFieldsDetails
) => {
  console.log("12-> CustomShare: submitSharingForm #4", {
    data,
    paths,
    files,
    defaultCustomShareFieldsDetails,
  });
  const sendEmailVal = data?.sendEmail || false;

  const emailFrom = data?.emailFrom || "";
  const emailTo = data?.emailTo || "";

  if (
    (!emailFrom || !emailTo) &&
    sendEmailVal &&
    customShareShareType === "external"
  ) {
    growl("", t("oneOrMoreRequiredItemsAreNotEntered"), false, true);
    return;
  }

  if (!data.shareUsernames && customShareShareType === "internal") {
    growl("", t("pleaseSelectUsersToShareSelectedItems"), false, true);
    return;
  }

  let baseURL = document.location.href + "";
  if (baseURL.indexOf("#") >= 0) {
    baseURL = baseURL.substring(0, baseURL.indexOf("#"));
  }

  // Build share object and submit
  let shareUsernamePermissionsStr = "(resume)(view)(slideshow)";

  for (const key in data) {
    if (key.startsWith("priv_") && data[key]) {
      shareUsernamePermissionsStr += `(${key.replace("priv_", "")})`;
      if (key.replace("priv_", "") === "write") {
        shareUsernamePermissionsStr += `(rename)(makedir)`;
      } else if (key.replace("priv_", "") === "delete") {
        shareUsernamePermissionsStr += `(deletedir)`;
      }
    }
  }

  const date = addDays(29);
  const txtDate = flatpickr.parseDate(data.txtDate, "m/d/Y") || date;

  let defaultPublishType = "";

  if (defaultCustomShareFieldsDetails?.chkReference) {
    defaultPublishType = "reference";
  } else if (defaultCustomShareFieldsDetails?.chkMove) {
    defaultPublishType = "move";
  } else if (defaultCustomShareFieldsDetails?.chkCopy) {
    defaultPublishType = "copy";
  }

  const formDetails = {
    command: "publish",
    allowUploads: data.fullaccess || data.priv_write || "false",
    attach: data.attach || "false",
    hide_download: data.hide_download || "false",
    attach_real: data.attach_real || "false",
    baseUrl: utils.encodeURILocal(baseURL),
    emailBcc: utils.stripDownEmails(data?.emailBcc),
    emailReplyTo: utils.stripDownEmails(data?.emailReplyTo),
    emailBody:
      utils.encodeURILocal(data.shareBody) ||
      defaultCustomShareFieldsDetails?.emailBody,
    share_comments: utils.encodeURILocal(data?.share_comments || ""),
    emailCc: utils.stripDownEmails(data?.emailCc),
    emailFrom: utils.stripDownEmails(emailFrom),
    emailSubject: utils.encodeURILocal(data?.emailSubject),
    emailTo: utils.stripDownEmails(emailTo),
    shareUsername: customShareShareType === "internal" ? true : false,
    shareUsernames: data.shareUsernames || "",
    shareUsernamePermissions: utils.removeDuplicatesPermissions(
      shareUsernamePermissionsStr
    ),
    expire: `${flatpickr.formatDate(txtDate, "m/d/Y")} ${
      data.txtTime || "23:59"
    }`,
    paths: utils.encodeURILocal(paths),
    publishType: data?.publishType || defaultPublishType,
    logins: data.logins,
    sendEmail: sendEmailVal,
    direct_link: data.direct_link || false,
  };

  if (data?.temp_username) {
    formDetails.temp_username = data.temp_username || "";
  }

  if (data?.temp_password) {
    formDetails.temp_password = data.temp_password || "";
  }

  const loading = new Loader({
    parentElement: `#modal_customShare .modal-card`,
  });
  console.log("12-> CustomShare: publish API call #5", { ...formDetails });
  apiCall("publish", {
    ...formDetails,
  })
    .then((response) => {
      loading.deleteLoader();
      const { commandResult } = response;
      let errorMessage = utils.textEncode(
        utils.sanitizePure(
          utils.decodeURILocal(commandResult?.response?.message)
        )
      );
      const hasErrorInResponse =
        (errorMessage?.toLowerCase().indexOf("error") >= 0 ||
          errorMessage?.toLowerCase().indexOf("denied") >= 0) &&
        !commandResult?.response?.username;

      if (
        errorMessage.indexOf("ERROR") == 0 &&
        errorMessage.indexOf("email_failed") > 0
      ) {
        errorMessage = t("sendingEmailFailed");
      }

      let buttons = [
        {
          label: "ok",
          close: true,
          classes: [""],
          onClick: () => {},
        },
      ];

      const shareWindowNoOpenInEmail = utils.getUserCustomizationValue(
        "shareWindowNoOpenInEmail"
      );
      const shareHideCopyLinkButton = utils.getUserCustomizationValue(
        "shareHideCopyLinkButton"
      );
      const shareWindowNoUserInfoAfterShare = utils.getUserCustomizationValue(
        "shareWindowNoUserInfoAfterShare"
      );
      const hideShareResultLink = utils.getUserCustomizationValue(
        "hideShareResultLink"
      );

      if (!hasErrorInResponse) {
        console.log("12-> CustomShare: hasErrorInResponse false #7");
        if (!shareWindowNoOpenInEmail) {
          console.log("12-> CustomShare: shareWindowNoOpenInEmail false #8");
          buttons.unshift({
            label: "openInEmailClient",
            classes: ["primary-button", "is-bordered", "mr-2"],
            id: "openInEmailClient-custom-share",
            onClick: () => {
              const emailToClient = utils
                .decodeURILocal(commandResult.response.message)
                .match(/href="([^"]*)/)[1];
              const link = utils.getEmailClientLink(emailToClient, [
                { varToReplace: "{files}", value: files },
              ]);
              window.open(
                link.replace(/\r/g, "%0D%0A").replace(/%3Cbr%3E/gi, "%0D%0A"),
                "_blank"
              );
            },
          });
        }

        if (!shareHideCopyLinkButton && !data.shareUsernames) {
          console.log(
            "12-> CustomShare: shareHideCopyLinkButton && data.shareUsernames false #9"
          );
          buttons.unshift({
            label: "copyLinkToClipboard",
            close: true,
            classes: ["primary-button", "is-bordered", "mr-2"],
            onClick: () => {
              navigator.clipboard.writeText(
                utils.decodeURILocal(commandResult.response.url)
              );
              growl(t("linkCopiedToClipboard"), "", 5000);
            },
          });
        }
      }

      console.log("12-> CustomShare: dialog update after published #6", {
        hasErrorInResponse,
        errorMessage,
        commandResult,
        data,
      });
      dialog.update({
        title: hasErrorInResponse ? t("publishFailed") : t("publishCompleted"),
        body: hasErrorInResponse
          ? errorResponseTemplate({
              errorMessage,
            })
          : resultTemplate({
              files,
              ...data,
              ...commandResult.response,
              shareWindowNoUserInfoAfterShare,
              hideShareResultLink,
              url: utils.decodeURILocal(commandResult.response.url),
            }),
        minWidth: "650px",
        minHeight: "350px",
        buttons,
      });

      const normalShareOpenEmailClient = utils.getUserCustomizationValue(
        "normalShareOpenEmailClient"
      );
      if (normalShareOpenEmailClient) {
        _$("#modal-btn-openInEmailClient-custom-share").el()?.click();
      }

      if (!hasErrorInResponse && commandResult?.response) {
        document.getElementById("customShareResultPassword").textContent =
          `${commandResult.response.password}` || "";
        document.getElementById("customShareResultURL").textContent =
          `${utils.decodeURILocal(commandResult.response.url || "")}` || "";
      }

      // TODO: refactor this unused code, Need to remove if condition
      if (_$(dialog.root).find("a[href^='mail']").length > 0) {
        let text = utils.decodeURILocal(
          _$(dialog.root).find("a[href^='mail']").attr("href")
        );
        if (text.indexOf("{files}") >= 0) {
          if (info.files) {
            let sub = info.files.substring(0, 250);
            if (info.files.length > 250) sub += "...";
            text = text.replace(/{files}/g, sub);
          } else {
            let sub = info.files.substring(0, 250);
            if (info.files.length > 250) sub += "...";
            text = text.replace(/{files}/g, sub);
          }
        }
        text = text.replace(/\r/g, "%0D%0A");
        let _sub = text.split("&body=")[0];
        let _asub = utils.decodeURILocal(text.split("&body=")[1]);
        _asub = _asub.replace(/<\/?[^>]+(>|$)/g, ""); //remove tags
        text = _sub + "&body=" + utils.encodeURILocal(_asub);
        console.log(text);

        _$(dialog.root).find("a[href^='mail']").attr("href", text);
      }
    })
    .catch((err) => {
      loading.deleteLoader();
      console.log(err);
    });
};

export const initCustomShare = ({ files, paths, customShareFieldsDetails }) => {
  const { visibleItems } = customShareFieldsDetails;
  tagInput = new TagInput();
  multiSelect = new MultiSelect();

  let visibleItemsOfCustomShareForm = {};
  visibleItems.forEach((item) => {
    if (item === "sendEmail") {
      visibleItemsOfCustomShareForm["showSendEmail"] = true;
      return;
    }
    visibleItemsOfCustomShareForm[item] = true;
  });

  const selectedFieldsToDecodeInCustomShareFields = [
    "emailSubject",
    "emailFrom",
    "emailTo",
    "emailCc",
    "emailBcc",
    "emailReplyTo",
    "share_comments",
    "share_keywords",
  ];

  selectedFieldsToDecodeInCustomShareFields.forEach((field) => {
    if (!customShareFieldsDetails[field]) {
      return;
    }
    customShareFieldsDetails[field] = utils.decodeURILocal(
      utils.decodeURILocal(customShareFieldsDetails[field] || "")
    );
  });

  const shareWindowEnableUsernameLookup = utils.getUserCustomizationValue(
    "shareWindowEnableUsernameLookup"
  );
  const shareWindowEnableMultipleUsernameSelection =
    utils.getUserCustomizationValue(
      "shareWindowEnableMultipleUsernameSelection"
    );

  const dialog = new Modal({
    title: "sharingFiles",
    body: customShareTemplate({
      files,
      paths,
      shareEmailBodyNoHTMLArea: false,
      ...visibleItemsOfCustomShareForm,
      ...customShareFieldsDetails,
      shareWindowEnableUsernameLookup,
      shareWindowEnableMultipleUsernameSelection,
    }),
    movable: true,
    closable: false,
    extraClasses: ["custom-share-modal"],
    uniqueId: "customShare",
    minWidth: "920px",
    minHeight: "900px",
    buttons: [
      {
        label: "cancel",
        close: true,
        classes: ["is-bordered", "mr-2"],
        onClick: () => {},
      },
      {
        label: "send",
        close: false,
        classes: [""],
        onClick: () => {
          console.log("12-> CustomShare: Pressed Submit button #1");
          const sendEmail = _$(dialog.root).find("#sendEmail", true);
          const emailFrom = _$(dialog.root).find("#emailFrom", true);
          const emailTo = _$(dialog.root).find("#emailTo", true);

          if (!sendEmail?.checked) {
            delete emailFrom?.dataset?.validate;
            delete emailTo?.dataset?.validate;
          } else {
            if (emailFrom) {
              emailFrom.dataset.validate = "required,multiple-emails";
            }

            if (emailTo) {
              emailTo.dataset.validate = "required,multiple-emails";
            }
          }

          if (customShareShareType === "internal") {
            if (!_$("#shareUsernames").hasClass("is-hidden")) {
              const shareUsernameValidation = validate(
                _$("#shareUsernames").el(),
                false
              );

              if (shareUsernameValidation?.length !== 0) {
                growl(
                  "",
                  t("pleaseSelectUsersToShareSelectedItems"),
                  false,
                  true
                );
                return;
              }
            }

            if (!_$("#shareUsernames-multiselect").hasClass("is-hidden")) {
              const shareUsernameValidation = validate(
                _$("#shareUsernames-multiselect").el(),
                false
              );

              if (shareUsernameValidation?.length !== 0) {
                growl(
                  "",
                  t("pleaseSelectUsersToShareSelectedItems"),
                  false,
                  true
                );
                return;
              }
            }
          }

          const validateFields = validate(dialog.root, true);
          console.log("12-> CustomShare: validateFields #2", validateFields);
          if (validateFields.length === 0) {
            const shareFormData = getShareFormData(dialog);
            console.log("12-> CustomShare: shareFormData #3", shareFormData);
            submitSharingForm(
              dialog,
              shareFormData,
              paths,
              files,
              customShareFieldsDetails
            );
          }
        },
      },
    ],
  });

  const { root } = dialog;
  const parent = _$(root);

  if (shareWindowEnableUsernameLookup && _$("#shareUsernames").el()) {
    const handleUsernameDebounce = utils.debounce((e) => {
      const value = e?.target?.value;
      if (!value) {
        tagInput.updateOptions({
          autoComplete: autoCompleteElement,
          helperText: t("typeInASearchTerm"),
        });
        return;
      }

      tagInput.updateOptions({
        autoComplete: autoCompleteElement,
        helperText: `${t("searching")}...`,
      });

      ajax
        .call({
          method: "GET",
          urlEncoded: true,
          data: {
            command: "lookup_form_field",
            form_name: "share_form",
            form_element_name: "shareUsernames",
            q: value,
          },
        })
        .then((res) => {
          setTimeout(() => {
            const usernames = res?.map((item) => {
              return { value: item.id, label: item.name };
            });

            tagInput.updateOptions({
              autoComplete: autoCompleteElement,
              options: usernames || value,
            });
          }, 500);
        });
    }, 500);

    const autoCompleteElement = tagInput.attach({
      input: "#shareUsernames",
      onInputChange: handleUsernameDebounce,
      helperText: t("typeInASearchTerm"),
    });
  }

  if (
    shareWindowEnableMultipleUsernameSelection &&
    _$("#shareUsernames-multiselect").el()
  ) {
    multiSelect.attach({
      input: "#shareUsernames-multiselect",
      leftLabel: t("availableUsers"),
      rightLabel: t("selectedUsers"),
    });

    ajax
      .call({
        data: {
          command: "lookup_form_field",
          form_name: "share_form",
          form_element_name: "shareUsernames",
          q: "",
        },
      })
      .then((res) => {
        const usernames = res?.map((item) => {
          return { value: item.id, label: item.name };
        });

        multiSelect.renderOptions({
          id: "shareUsernames-multiselect",
          options: usernames,
        });
      });
  }

  const daysElement = parent.find("#txtdays", true);

  const calendar = flatpickr("#date-picker", {
    dateFormat: "m/d/Y",
  });

  if (daysElement) {
    calendar.setDate(addDays(daysElement.value || 29));

    _$(daysElement).on("input", (e) => {
      const days = e.target.value;

      // set value of calendar
      calendar.setDate(addDays(days));
    });
  }

  currentShareBodyEditor = parent.find("#emailBody", true);

  if (currentShareBodyEditor) {
    sceditor.create(currentShareBodyEditor, {
      format: "xhtml",
      emoticonsEnabled: false,
      width: "100%",
      readOnly: false,
      toolbarExclude:
        "emoticon,youtube,table,code,quote,horizontalrule,image,email,link,unlink,emoticon,youtube,date,time,ltr,rtl,print,maximize,",
      style:
        "/WebInterface/new-ui/assets/js/thirdparty/SCEditor/themes/content/default.min.css",
    });

    const theme = localStorage.getItem("data-theme");
    // Use CSSOM instead of .css() to avoid CSP violation
    const editorInstance = sceditor.instance(currentShareBodyEditor);
    if (editorInstance && editorInstance.getBody) {
      const editorBody = editorInstance.getBody();
      if (editorBody && editorBody.style) {
        editorBody.style.setProperty('color', theme === "dark" ? "#ffffff" : "#222222");
      }
    }

    const updateEditor = (text) => {
      text = text.replace(/-NEW-LINE-/g, "<br>");

      try {
        const editor = sceditor.instance(currentShareBodyEditor);
        if (editor) {
          editor.val(
            text.replace(
              /{files}/g,
              files
                .split("\r\n")
                .map((path) => `<p>${utils.doubleEncodeHtml(path)}</p>`)
                .join("")
            )
          );
        }
      } catch (e) {}
    };

    const emailBodyText = utils.decodeURILocal(
      utils.decodeURILocal(customShareFieldsDetails?.emailBody)
    );

    updateEditor(emailBodyText);
  }

  const shareUsername = customShareFieldsDetails.shareUsername;

  const generateUsernamePassword = () => {
    const passwordLength =
      store.userInfo?.temp_accounts_length ||
      store?.userInfo?.random_password_length ||
      8;
    const generatedUser = utils.generatePassword(passwordLength);

    const passwordRule = {
      random_password_length: passwordLength,
      min_password_numbers: store?.userInfo.min_password_numbers,
      min_password_lowers: store?.userInfo.min_password_lowers,
      min_password_uppers: store?.userInfo.min_password_uppers,
      min_password_specials: store?.userInfo.min_password_specials,
    };

    const generatedPassword = utils.generatePasswordBasedOnRules(passwordRule);

    _$("#share_generate_user").val(generatedUser);
    _$("#share_generate_pass").val(generatedPassword);
  };

  _$("#shareGenerateUserPass").on("click", generateUsernamePassword);

  const bindOptionChange = ({
    selector,
    enable,
    disable,
    validate,
    callback,
  }) => {
    const trigger = () => {
      const toEnable = enable && parent.find(enable);
      const toDisable = disable && parent.find(disable);
      const elem = parent.find(`${selector}:checked`);
      if (callback) callback(elem, selector);

      if (elem && elem.length > 0) {
        const validation = !validate || validate(elem.val());
        toEnable?.each((el) => _$(el).toggleClass("is-hidden", !validation));
        toDisable?.each((el) => _$(el).toggleClass("is-hidden", validation));
      } else {
        toEnable?.each((el) => _$(el).addClass("is-hidden"));
        toDisable?.each((el) => _$(el).removeClass("is-hidden"));
      }
    };
    parent.find(selector).each((input) => {
      _$(input).on("change", trigger);
    });
    trigger();
  };

  customShareShareType = shareUsername ? "internal" : "external";

  bindOptionChange({
    selector: 'input[type="checkbox"][name="shareUsernameInput"]',
    enable: ".multiselect-wrapper",
    disable: ".autocomplete-wrapper",
    validate: (value) => value === "multiselect",
    callback: () => {
      const isChecked = _$("#shareUsernameInput").prop("checked");
      if (isChecked) {
        const hasShareTagInput =
          _$("#shareUsernames").el() &&
          !_$("#shareUsernames").hasClass("is-hidden");

        if (hasShareTagInput) {
          const options = tagInput.getSelectedOptions({ id: "shareUsernames" });

          multiSelect.updateSelectedOptions({
            id: "shareUsernames-multiselect",
            options: options,
          });
        }
      } else {
        const hasShareMultiSelect =
          _$("#shareUsernames-multiselect").el() &&
          !_$("#shareUsernames-multiselect").hasClass("is-hidden");

        if (hasShareMultiSelect) {
          const options = multiSelect.getSelectedOptions(
            "shareUsernames-multiselect"
          );

          if (tagInput) {
            tagInput.updateSelectedOption({
              id: "shareUsernames",
              options: options,
            });
          }
        }
      }
    },
  });

  bindOptionChange({
    selector: 'input[type="checkbox"][name="shareUsernameInput"]',
    enable: ".multiselect-wrapper",
    disable: ".autocomplete-wrapper",
    validate: (value) => value === "multiselect",
  });

  bindOptionChange({
    selector: 'input[type="checkbox"][name="advanced"]',
    enable: ".advanced",
  });

  bindOptionChange({
    selector: 'input[type="radio"][name="shareType"]',
    enable: `.${shareUsername ? "external" : "internal"}`,
    disable: `.${shareUsername ? "internal" : "external"}`,
    validate: (value) => {
      const defaultChecked = shareUsername ? "external" : "internal";
      customShareShareType = value ? value : defaultChecked;
      return value === defaultChecked;
    },
    callback: (elem) => {
      const value = elem.val();
      if (value === "internal") {
        parent.find(".external")?.each((el) => _$(el).addClass("is-hidden"));
      }
    },
  });

  bindOptionChange({
    selector: 'input[type="radio"][name="generateUserPass"]',
    enable: ".generate",
    disable: null,
    validate: (value) => value === "generate",
    callback: generateUsernamePassword,
  });
};
